import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

export const AnimatedSection = ({ 
  children, 
  animation = 'fadeInUp', 
  delay = 0, 
  className = '',
  duration = 600 
}) => {
  const [ref, isVisible] = useIntersectionObserver();

  const animationClasses = {
    fadeInUp: isVisible ? 'animate-fadeInUp' : 'opacity-0 translate-y-8',
    fadeIn: isVisible ? 'animate-fadeIn' : 'opacity-0',
    slideInLeft: isVisible ? 'animate-slideInLeft' : 'opacity-0 -translate-x-8',
    slideInRight: isVisible ? 'animate-slideInRight' : 'opacity-0 translate-x-8',
    scaleIn: isVisible ? 'animate-scaleIn' : 'opacity-0 scale-95',
    staggerUp: isVisible ? 'animate-staggerUp' : 'opacity-0 translate-y-4'
  };

  return (
    <div
      ref={ref}
      className={`transition-all duration-${duration} ease-out ${animationClasses[animation]} ${className}`}
      style={{
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
};

export const StaggeredContainer = ({ children, staggerDelay = 100, className = '' }) => {
  const [ref, isVisible] = useIntersectionObserver();
  
  return (
    <div ref={ref} className={className}>
      {React.Children.map(children, (child, index) => (
        <AnimatedSection
          key={index}
          animation="fadeInUp"
          delay={isVisible ? index * staggerDelay : 0}
          duration={600}
        >
          {child}
        </AnimatedSection>
      ))}
    </div>
  );
};